<script>
import Common from "./Common";
export default {
    mixins:[Common],
    computed: {
      processingGroups() {
        return this.$store.state.processings.groupMap;
      },
      equipments() {
        return this.$store.state.equipments;
      },
      itemGroups() {
        return this.$store.state.itemGroups;
      },
      sizeItems() {
        return this.$store.state.sizeItems;
      },
      sizeItemMap() {
        return this.$store.state.sizeItemMap;
      },
      staffMap() {
        return this.$store.state.staffMap;
      },
      userId() {
        return this.$store.state.userProfile.userId
      },
    },
    methods: {

        // ----------------------------------
        //
        // ----------------------------------

        getStaffName(id){
          let stf = this.staffMap[id];
          if (stf){
            return stf.name;
          }
          else return "";
        },


        // ----------------------------------
        // トーストメッセージの表示
        // ----------------------------------
        showErrorToast(message){
          this.$eventHub.$emit('show-snackbar', {
            type:'error',
            message:message,
          });
            console.log(message);
        },
        showMessageToast(message){
            this.$eventHub.$emit('show-snackbar', {
                type:'info',
                message:message,
            });
            console.log(message);
        },

    },
}
</script>